module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-contact-saska-small-0e175aed92ed397b9bb77cafa4ba2ac3.png";